// extracted by css-extract-rspack-plugin
export default {"root":"_1Sw4bFuNkX18fUDXAHRAcR"};